import * as React from "react";

export function SvgChart() {
  return (
    <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M62.3334 33L48.6226 53.5662C48.1966 54.2051 47.2395 54.1455 46.8961 53.4587L41.104 41.8746C40.7606 41.1878 39.8034 41.1282 39.3775 41.7671L25.6667 62.3333"
        stroke="#CCD2E3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="11" y="11" width="66" height="66" rx="2" stroke="#CCD2E3" strokeWidth="2" />
    </svg>
  );
}
